import { Resolutions, Timeout } from '../common/const';
import { isDev } from '../common/utils';

export const initBtnTooltip = () => {
    let timeout = null;
    const options = {
        fav: { title: "избранное", src: isDev() ? "fav.html" : "/personal/favorites/" },
        comp: { title: "сравнение", src: isDev() ? "compare.html" : "/personal/compare/" }
    };

    function getTooltipContent(tag) {
        return `
            <div class="tooltip-block f-caption">Товар добавлен в ${options[tag].title}</div>
            <div class="tooltip-block tooltip-block--center">
                <a class="tooltip-link f-body-s-bold link link--pagination-side" href="${options[tag].src}"><span>Перейти</span>
                    <svg class="icon icon--arrow-right">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                </a>
            </div>
        `;
    }

    $(`body`).on(`click`, `[data-fav-add]`, function() {
        const id = $(this).closest(`[data-product-id]`).attr(`data-product-id`);
        const attr = $(this).attr(`data-fav-add`);
        const $btns = $(`[data-product-id="${id}"]`).find(`[data-fav-add=${attr}]`);
        const $popup = $(`.popup--fav`);
        $btns.toggleClass(`active`);

        if (Resolutions.IS_DP()) {
            let text;
            if ($btns.hasClass(`active`)) {
                text = getTooltipContent(attr);
                $btns.tooltipster(`content`, text);
            } else if (!$btns.hasClass(`active`)) {
                if (attr === `fav`) text = `Добавить в избранное`;
                else if (attr === `comp`) text = `Добавить в сравнение`;
                $btns.tooltipster(`content`, text);
            }
        } else {
            if ($btns.hasClass(`active`)) {
                let text, href;
                clearTimeout(timeout);
                if (attr === `fav`) {
                    text = `Товар добавлен в избранное`;
                    href = isDev() ? `favourites.html` : `/personal/favorites/`;
                } else if (attr === `comp`) {
                    text = `Товар добавлен в сравнение`;
                    href = isDev() ? `compare.html` : `/personal/compare/`;
                }

                $popup.find(`.popup__lead`).text(text);
                $popup.find(`.popup__link`).attr(`href`, href);
                $popup.fadeIn(Timeout.ANIMATION_TOGGLE);

                timeout = setTimeout(function () {
                    $popup.fadeOut(Timeout.ANIMATION_TOGGLE);
                }, Timeout.SUPERLONG_TIMEOUT);
            }
        }
    });

    $(`body`).on(`click`, `[data-popup-close]`, function() {
        clearTimeout(timeout);
    });
}
